import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import Login from "../pages/Login";

export const auth = {
  LOGIN: {
    path: "/login",
    exact: true,
    private: false,
    component: Login,
  },
  FORGET: {
    path: "/forget-password",
    exact: true,
    private: false,
    component: ForgotPasswordPage,
  },
  RESET: {
    path: "/reset-password/:token/:code",
    exact: true,
    private: false,
    component: ResetPasswordPage,
  },
};
